module.exports = __webpack_public_path__ + "static/media/user_avatar.032778d1.png";